exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multi-nodal-table .sub-row td {\n  padding: 0px 0px 0px 10px;\n}\n.multi-nodal-table {\n  padding: 0;\n}\n\n.multi-nodal-table table th {\n  white-space: normal;\n}\n\n.multi-nodal-table .react-bs-table table.table td {\n  padding: 5px;\n}\n", ""]);

// exports
